import { Metafield } from '../../models/Product';

const useProducts = () => {
    const getMetafield = (metafields: Metafield[], key: string): string => {
        const getField = metafields.find((elem) =>
            elem != null ? elem.key == key : false
        );
        return getField ? getField.value : null;
    };

    const getMultiplierFromMetafields = (metafields: Metafield[]): boolean => {
        const getField = getMetafield(metafields, 'min_order_multiplier');
        return getField ? getField == 'true' : false;
    };

    const getMinOrderQtyFromMetafields = (metafields: Metafield[]): number => {
        const getField = getMetafield(metafields, 'min_order_quantity');
        return getField ? Number(getField) : 0;
    };

    return {
        getMetafield,
        getMultiplierFromMetafields,
        getMinOrderQtyFromMetafields,
    };
};

export default useProducts;
